import { Controller } from '@hotwired/stimulus'
import { useTransition } from 'stimulus-use'

export default class extends Controller {
    static targets = ['toggleable', 'icon']

    connect() {
        // Setup transitions
        useTransition(this, {
            element: this.toggleableTarget,
        })

        // First, check if hidden attribute exists - this is our primary determinant
        const hasHiddenAttribute = this.toggleableTarget.hasAttribute('hidden')

        // Initialize icon if it exists
        if (this.hasIconTarget) {
            // Set initial icon state based on whether the toggleable element is hidden
            this.iconTargets.forEach(icon => {
                if (hasHiddenAttribute) {
                    // Element is hidden, show down arrow
                    if (icon.dataset.iconType === 'down') {
                        icon.classList.remove('hidden')
                    } else if (icon.dataset.iconType === 'up') {
                        icon.classList.add('hidden')
                    }
                } else {
                    // Element is visible, show up arrow
                    if (icon.dataset.iconType === 'up') {
                        icon.classList.remove('hidden')
                    } else if (icon.dataset.iconType === 'down') {
                        icon.classList.add('hidden')
                    }
                }
            })
        }

        if (hasHiddenAttribute) {
            // Element should start hidden - ensure it's hidden properly
            this.hideElement(false) // Don't animate initial state
        } else {
            // Element should start visible - ensure it's visible
            this.showElement()
        }
    }

    toggle() {
        // Simply toggle based on current hidden state
        const isCurrentlyHidden = this.toggleableTarget.hasAttribute('hidden')

        if (isCurrentlyHidden) {
            this.showElement()
        } else {
            this.hideElement(true) // Animate when hiding
        }
    }

    // Helper to show element
    showElement() {
        this.toggleableTarget.removeAttribute('hidden')
        this.toggleableTarget.classList.remove('hidden')
        this.toggleableTarget.classList.add('transition-in')
        this.toggleableTarget.classList.remove('transition-out')

        // Update icon if it exists
        if (this.hasIconTarget) {
            this.iconTarget.classList.remove('hidden')
            this.iconTargets.forEach(icon => {
                if (icon.dataset.iconType === 'down') {
                    icon.classList.add('hidden')
                } else if (icon.dataset.iconType === 'up') {
                    icon.classList.remove('hidden')
                }
            })
        }
    }

    // Helper to hide element
    hideElement(animate = true) {
        if (animate) {
            // Animate then hide
            this.toggleableTarget.classList.remove('transition-in')
            this.toggleableTarget.classList.add('transition-out')

            setTimeout(() => {
                this.toggleableTarget.setAttribute('hidden', '')
                this.toggleableTarget.classList.add('hidden')
            }, 300)
        } else {
            // Hide immediately (no animation)
            this.toggleableTarget.setAttribute('hidden', '')
            this.toggleableTarget.classList.add('hidden')
            this.toggleableTarget.classList.remove('transition-in')
            this.toggleableTarget.classList.add('transition-out')
        }

        // Update icon if it exists
        if (this.hasIconTarget) {
            this.iconTargets.forEach(icon => {
                if (icon.dataset.iconType === 'up') {
                    icon.classList.add('hidden')
                } else if (icon.dataset.iconType === 'down') {
                    icon.classList.remove('hidden')
                }
            })
        }
    }
}
